import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var PressIcon = function PressIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.9393C20 10.8814 19.1452 10.0207 18.0945 10.0207C17.7904 10.0207 17.5029 10.0932 17.2476 10.2214C16.9887 9.47086 16.2798 8.93043 15.4474 8.93043C15.0729 8.93043 14.7236 9.04022 14.4287 9.22886C14.094 8.6757 13.4892 8.30552 12.8002 8.30552C12.5372 8.30552 12.2865 8.35946 12.0584 8.45687V6.16266C12.0584 5.1425 11.2341 4.3125 10.2208 4.3125C9.20757 4.3125 8.38322 5.1425 8.38322 6.16266V12.1328C8.01676 11.5505 7.44832 11.145 6.78053 10.9898C6.10677 10.8332 5.41276 10.9506 4.82659 11.32L4.27316 11.6689C4.01151 11.8339 3.92334 12.1759 4.07226 12.4481C4.09689 12.4931 6.54666 16.9761 7.54056 19.1204C7.55755 19.157 7.57454 19.1931 7.59161 19.2286C7.99186 20.0624 8.61891 20.7627 9.40501 21.2538C10.1863 21.7419 11.0866 22 12.0085 22H14.9593C16.2867 22 17.5371 21.4819 18.4801 20.5413C19.4231 19.6007 19.9493 18.3467 19.9618 17.0103L20 12.9291C20 12.9281 19.9998 12.9272 19.9998 12.9263C19.9998 12.9254 20 12.9245 20 12.9236V11.9393H20ZM17.6611 19.7089C16.9375 20.4307 15.978 20.8282 14.9593 20.8282H12.0086C10.5771 20.8282 9.25458 20.0002 8.6394 18.7187C8.62454 18.6878 8.60972 18.6564 8.59506 18.6247C7.77013 16.845 6.02415 13.6003 5.35609 12.3687L5.44418 12.3131C5.76657 12.1099 6.1482 12.0453 6.51889 12.1315C6.88949 12.2177 7.20452 12.444 7.40584 12.7689L8.47143 14.4887C8.60887 14.7105 8.87556 14.8136 9.12529 14.7418C9.37491 14.6698 9.54699 14.44 9.54699 14.1785V6.16266C9.54699 5.78858 9.84929 5.48421 10.2209 5.48421C10.5924 5.48421 10.8947 5.78858 10.8947 6.16266V12.9236C10.8947 13.2471 11.1553 13.5094 11.4766 13.5094C11.798 13.5094 12.0585 13.2471 12.0585 12.9236V10.2241C12.0585 9.8123 12.3912 9.47727 12.8002 9.47727C13.2092 9.47727 13.542 9.8123 13.542 10.2241V12.9236C13.542 13.2471 13.8025 13.5094 14.1238 13.5094C14.4452 13.5094 14.7057 13.2471 14.7057 12.9236V10.849C14.7057 10.4372 15.0384 10.1022 15.4474 10.1022C15.8564 10.1022 16.1891 10.4372 16.1891 10.849V12.9236C16.1891 13.2471 16.4497 13.5094 16.771 13.5094C17.0923 13.5094 17.3529 13.2471 17.3529 12.9236V11.9393C17.3529 11.5275 17.6856 11.1925 18.0946 11.1925C18.5036 11.1925 18.8363 11.5275 18.8363 11.9393V12.9201L18.7983 16.9993C18.7886 18.0248 18.3848 18.9871 17.6611 19.7089Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "0.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52413 6.87325C6.84547 6.87325 7.10599 6.61094 7.10599 6.28739C7.10599 4.5694 8.49421 3.17171 10.2005 3.17171C11.9068 3.17171 13.295 4.5694 13.295 6.28739C13.295 6.61094 13.5556 6.87325 13.8769 6.87325C14.1982 6.87325 14.4588 6.61094 14.4588 6.28739C14.4588 3.92332 12.5485 2 10.2005 2C7.85249 2 5.94226 3.92332 5.94226 6.28739C5.94226 6.61098 6.20278 6.87325 6.52413 6.87325Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep),
    strokeWidth: "0.625"
  })));
};
PressIcon.propTypes = {
  iconColor: PropTypes.string
};
PressIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PressIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var PressIcon$1 = withTheme(PressIcon);

export default PressIcon$1;
